import request from '@/utils/request'
const qs = require('qs')

// 获取线路投放品牌
export function getMaterialBasicInfoPage (data) {
  return request({
    url: '/ooh-msp/v2/open/msp/getmaterialbasicinfopage',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
// 获取线路投放品牌
export function getBrandMspInfo (data) {
  return request({
    url: '/ooh-msp/v2/open/msp/getbrandmspinfo',
    method: 'post',
    data: qs.stringify(data),
    timeout: 100000
  })
}
// 获取订单资源发布和监播详情
export function getOrderPublishInfoPage (data) {
  return request({
    url: '/ooh-msp/v2/open/msp/getorderpublishinfopage',
    method: 'post',
    data: qs.stringify(data),
    timeout: 100000
  })
}
// 获取订单履约进程
export function getorderprogresslist (data) {
  return request({
    url: '/ooh-msp/v2/open/msp/getorderprogresslist',
    method: 'post',
    data: qs.stringify(data),
    timeout: 100000
  })
}
// 获取站点指定时间段上刊素材基本信息
export function getstationmaterialhistorypage (data) {
  return request({
    url: '/ooh-msp/v2/open/msp/getstationmaterialhistorypage',
    method: 'post',
    data: qs.stringify(data),
    timeout: 100000
  })
}
